import { Option } from "@cs/components/src/Select";

import { v4 as uuid } from "uuid";

export const actionContextOptions = [
  "Asset",
  "Collection",
  "Bulk",
  "Saved Search",
  "Shared Asset",
  "Shared Collection",
  "None",
].map((label) => ({
  label,
  value: label.toUpperCase().replace(" ", "_"),
}));

export const actionTypeOptions = ["Post", "Open"].map((label) => ({
  label,
  value: label.toUpperCase(),
}));

export const webhookEventTypeOptions = [
  "Assets",
  "Collections",
  "Groups",
  "Jobs",
  "Metadata",
  "Notifications",
  "Storages",
  "Users",
].map((label) => ({
  label,
  value: label.toLowerCase().replace(" ", "_"),
}));

export const webhookRealmOptions = [
  "All",
  "ACLs",
  "Approval status",
  "Contents",
  "Entity",
  "File sets",
  "Files",
  "Formats",
  "Groups",
  "Jobs",
  "Keyframes",
  "Metadata",
  "Metadata Categories",
  "Metadata Field",
  "Metadata View",
  "Proxies",
  "Relations",
  "Segments",
  "Segments metadata",
  "Shares",
  "Share users",
  "Storages",
  "Subtitles",
  "Versions",
].map((label) => ({
  label,
  value: label.toLowerCase().replace(" ", "_"),
}));

export const webhookOperationOptions = [
  "All",
  "Create",
  "Update",
  "Delete",
  "Purge",
  "Restore",
  "Download",
].map((label) => ({
  label,
  value: label.toLowerCase().replace(" ", "_"),
}));

export const objectTypeOptions = [
  "Assets",
  "Collections",
  "Segments",
  "Search",
].map((label) => ({
  label,
  value: label.toLowerCase().replace(" ", "_"),
}));

export const categoryOptions = ["Default"].map((label) => ({
  label,
  value: label.toLowerCase().replace(" ", "_"),
}));

export const categoryOptionsSegments = ["Generic", "Tag"].map((label) => ({
  label,
  value: label.toLowerCase().replace(" ", "_"),
}));

export const componentOptions = [
  {
    label: "Custom Action",
    value: "custom_action_config",
  },
  {
    label: "Webhook",
    value: "webhook_config",
  },
  {
    label: "Schedule",
    value: "schedule_config",
  },
  {
    label: "Metadata View",
    value: "metadata_view_config",
  },
  {
    label: "List Input",
    value: "list_input_config",
  },
];

export const scriptLocationOptions = [
  {
    label: "Node",
    value: "node",
  },
];

export const linkedVariableTypeOptions = [
  {
    label: "System Domain",
    value: "system_domain_id",
    context: "iconik_script_config",
    filter: (variable: VariableConfig) => variable.dataType === "organization",
  },
  {
    label: "Dropdown Options",
    value: "dropdown_option_list",
    context: "custom_action_config",
    filter: (variable: VariableConfig) =>
      variable.dataType === "dropdown_option_list",
  },
];

export const linkedVariableTypeOptionsCustomAction = [];

export const sortByOption = (options: Option[]) => (a: Option, b: Option) => {
  return (
    options.findIndex(({ value }) => value === a.value) -
    options.findIndex(({ value }) => value === b.value)
  );
};

// export const newCustomAction = (): CustomActionConfig => ({
//   type: 'custom_action_config',
//   id: uuid(),
//   title: '',
//   requestType: 'POST',
//   contexts: [],
//   script: '',
//   scriptLocation: 'node',
//   variables: [],
// });

// export const newVariable = (): VariableConfig => ({
//   type: 'variable_config',
//   id: uuid(),
//   key: '',
//   title: '',
//   description: '',
//   dataType: 'string',
//   required: false,
//   // enabledIds: pluginConfig.components.map(({ id }) => id),
// });

// export const newWebhookQuery = (): WebhookConfigQuery => ({
//   type: 'webhook_config_query',
//   id: uuid(),
//   operator: 'and',
//   terms: [],
// });

// export const newWebhook = (): WebhookConfig => ({
//   type: 'webhook_config',
//   id: uuid(),
//   title: '',
//   eventType: 'assets',
//   realm: 'all',
//   operation: 'all',
//   query: newWebhookQuery(),
//   script: '',
//   scriptLocation: 'node',
// });

// export const newWebhookQueryTerm = (): WebhookConfigQueryTerm => ({
//   type: 'webhook_config_query_term',
//   id: uuid(),
//   operator: '==',
//   dataType: 'text',
//   field: '',
// });

// export const newSchedule = (): ScheduleConfig => ({
//   type: 'schedule_config',
//   id: uuid(),
//   title: '',
//   script: '',
//   scriptLocation: 'node',
//   cron: '0/10 * ? * * *',
// });

// export const newMetadataView = (): MetadataViewConfig => ({
//   type: 'metadata_view_config',
//   id: uuid(),
//   title: '',
//   variables: [],
//   objectType: 'assets',
//   category: '',
// });

// export const newListInput = (): ListInputConfig => ({
//   type: 'list_input_config',
//   id: uuid(),
//   title: '',
//   variables: [],
// });

// export const newPluginConfig = (): PluginConfigItem => {
//   const id = uuid();
//   return {
//     id,
//     sk: id,
//     pk: 'iconik_plugin_config',
//     type: 'iconik_plugin_config',
//     title: '',
//     description: '',
//     components: [],
//     variables: [],
//   };
// };

// export const newScriptConfig = (): ScriptConfigItem => {
//   const id = uuid();
//   return {
//     id,
//     sk: id,
//     pk: 'iconik_script_config',
//     type: 'iconik_script_config',
//     title: '',
//     description: '',
//     variables: [],
//     script: '',
//     scriptLocation: 'node',
//   };
// };

export const newPluginInstance = (
  systemDomainId: string,
  pluginConfigId: string
): PluginInstanceItem => {
  const id = uuid();
  return {
    id,
    sk: `${systemDomainId}_${id}`,
    pk: "iconik_plugin_instance",
    type: "iconik_plugin_instance",
    systemDomainId,
    pluginConfigId,
    variables: [],
    titles: [],
  };
};

/**
 * Returns true for component types that should be shown to the user in the
 * components list and badge views.
 *
 * Intentionally excluded (human-approved, non-user-facing plumbing):
 *   - internal_processor_config: SFN-dispatched internal processor — operates
 *     silently in the background; exposing it in the UI adds noise for admins.
 *   - list_input_config: provides a variable input contract consumed by other
 *     components; it has no standalone UI meaning and was already hidden from
 *     all badge views before this predicate was introduced.
 *
 * Both types still register and function normally on the backend.
 */
export const isUserVisibleComponent = (componentType?: string): boolean =>
  componentType !== "internal_processor_config" &&
  componentType !== "list_input_config";

export const componentTypeInfo = (componentType?: string) => {
  let title = "Unknown";
  let color = "var(--blue300)";
  let section = "unknown";
  if (componentType === "variable_config") {
    title = "Variable";
    section = "variable";
    color = "var(--variable)";
  } else if (componentType === "custom_action_config") {
    title = "Action";
    section = "component";
    color = "var(--customAction)";
  } else if (componentType === "webhook_config") {
    title = "Webhook";
    section = "component";
    color = "var(--webhook)";
  } else if (componentType === "iconik_plugin_config") {
    title = "Plugin";
    section = "plugin";
  } else if (componentType === "iconik_script_config") {
    title = "Script";
    section = "script";
  } else if (componentType === "schedule_config") {
    title = "Schedule";
    section = "component";
    color = "var(--schedule)";
  } else if (componentType === "metadata_view_config") {
    title = "Metadata View";
    section = "component";
    color = "var(--metadataView)";
  } else if (componentType === "list_input_config") {
    title = "List Input";
    section = "component";
    color = "var(--listInput)";
  } else if (componentType === "internal_processor_config") {
    title = "Internal Processor";
    section = "component";
    color = "var(--blue300)";
  }

  return {
    title,
    color,
    section,
  };
};
